<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i class="fa fa-bars mr-1"></i>
            <span>Multigrid</span>
          </b-col>
        </b-row>
      </b-card-header>

      <b-row class="ml-1 mt-2">
        <b-col>
          <b-form-checkbox size="sm" v-model="table_e.visible"
            >An e-table (excel table) style</b-form-checkbox
          >
        </b-col>
      </b-row>

      <b-card-body v-if="table_e.visible">
        <e-table
          v-if="table_e.visible"
          :refid="table_e.refid"
          :busy="table_e.busy"
          :icon="table_e.icon"
          :showtoolbar="table_e.showtoolbar"
          :showfab="table_e.showfab"
          :showsheets="table_e.showsheets"
          :showpages="table_e.showpages"
          :showrowcount="table_e.showrowcount"
          :showautoadd="table_e.showautoadd"
          :tools="table_e.tools"
          :fields="table_e.fields"
          :items="table_e.items"
          @click="table_e_click"
          @select="table_e_select"
          @change="updateit"
        />

        <b-row class="mt-2">
          <b-col>
            <b-form-checkbox size="sm" v-model="table_e.busy"
              >Busy?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_e.showtoolbar"
              >Toolbar?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_e.showfab"
              >FAB?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_e.showsheets"
              >Sheets?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_e.showpages"
              >Pages?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_e.showrowcount"
              >Rowcount?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_e.showautoadd"
              >Autoadd?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-input
              type="text"
              v-model="table_e.icon"
              placeholder="Enter icon"
              size="sm"
              :style="'width: 200px'"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="small">
          <b-col>
            event: <br />
            <span v-html="table_e.event"></span>
          </b-col>
        </b-row>
        <!-- <b-row class="small">
          <b-col>
            selected: <br />
            {{ table_e.selected }}
          </b-col>
        </b-row> -->
        <!-- <b-row class="small">
          <b-col>
            Changed: <br />
            {{ changed }}
          </b-col>
        </b-row> -->
        <!-- <b-row>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_1.visible"
              >Table 1 primary</b-form-checkbox
            >
            {{ table_1.actions }}
            <d-table
              v-if="table_1.visible"
              refid="table_1"
              :busy="table_1.busy"
              :limit="15"
              :toolbarinit="table_1.toolbarinit"
              :toolbar="table_1.toolbar"
              :badges="table_1.badges"
              :fields="table_1.fields"
              :items="table_1.items"
            >
            </d-table>
            <b-button @click="tb_add"> add </b-button>
            <b-button @click="tb_disable"> disable </b-button>
          </b-col>
        </b-row> -->

        <!-- <b-row>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_2.visible"
              >Table 2 nested</b-form-checkbox
            >
            <d-table
              v-if="table_2.visible"
              classdivtable="availtable datatable nested"
              refid="table_2"
              :limit="10"
              :fields="[
                {
                  key: 'selected',
                  label: '...',
                },
                {
                  key: 'icon',
                  label: '',
                  class: 'text-center w-30px',
                },
                {
                  key: 'eventcode',
                  label: 'Event Code',
                  sortable: true,
                  class: 'text-left',
                },
                {
                  key: 'dateevent',
                  label: 'Date Event',
                  sortable: true,
                },
                {
                  key: 'eventname',
                  label: 'Event Name',
                  sortable: true,
                },
                {
                  key: 'acccode',
                  label: 'Accounting Code',
                  sortable: true,
                },
                {
                  key: 'vatregion',
                  label: 'VAT Region',
                  sortable: true,
                },
                {
                  key: 'closed',
                  label: 'Closed',
                  sortable: true,
                },
                {
                  key: 'salesgroup',
                  label: 'Sales Group',
                  sortable: true,
                },
                {
                  key: 'actions',
                  label: 'Actions',
                  class: 'actions w-100px',
                },
              ]"
              :showpages="false"
              :busy="false"
            ></d-table>
          </b-col>
        </b-row> -->
      </b-card-body>

      <b-row class="ml-1 mt-2">
        <b-col>
          <b-form-checkbox size="sm" v-model="table_d.visible"
            >An d-table table style</b-form-checkbox
          >
        </b-col>
      </b-row>

      <b-row class="ml-1 mt-2">
        <b-col>
          <b-form-checkbox size="sm" v-model="table_r.visible"
            >An r-table table style</b-form-checkbox
          >
        </b-col>
      </b-row>

      <b-card-body v-if="table_d.visible">
        <d-table
          v-if="table_d.visible"
          :refid="table_d.refid"
          :busy="table_d.busy"
          :selectall="table_d.selectall"
          :icon="table_d.icon"
          :showtoolbar="table_d.showtoolbar"
          :showfab="table_d.showfab"
          :showsheets="table_d.showsheets"
          :showpages="table_d.showpages"
          :showrowcount="table_d.showrowcount"
          :showautoadd="table_d.showautoadd"
          :tools="table_d.tools"
          :fields="table_d.fields"
          :badges="table_d.badges"
          :items="table_d.items"
          @click="table_d_click"
        />
        <!-- 
    @click="table_e_click"
          @select="table_e_select"
          @change="updateit" -->

        <b-row class="mt-2">
          <b-col>
            <b-form-checkbox size="sm" v-model="table_d.busy"
              >Busy?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_d.selectall"
              >Select All?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_d.showtoolbar"
              >Toolbar?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_d.showfab"
              >FAB?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_d.showsheets"
              >Sheets?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_d.showpages"
              >Pages?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_d.showrowcount"
              >Rowcount?</b-form-checkbox
            >
          </b-col>
          <!-- <b-col>
            <b-form-checkbox size="sm" v-model="table_d.showautoadd"
              >Autoadd?</b-form-checkbox
            >
          </b-col> -->
          <b-col>
            <b-form-input
              type="text"
              v-model="table_d.icon"
              placeholder="Enter icon"
              size="sm"
              :style="'width: 200px'"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="small">
          <b-col>
            event: <br />
            <span v-html="table_d.event"></span>
          </b-col>
        </b-row>
        <!-- <b-row class="small">
          <b-col>
            selected: <br />
            {{ table_e.selected }}
          </b-col>
        </b-row> -->
        <!-- <b-row class="small">
          <b-col>
            Changed: <br />
            {{ changed }}
          </b-col>
        </b-row> -->
        <!-- <b-row>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_1.visible"
              >Table 1 primary</b-form-checkbox
            >
            {{ table_1.actions }}
            <d-table
              v-if="table_1.visible"
              refid="table_1"
              :busy="table_1.busy"
              :limit="15"
              :toolbarinit="table_1.toolbarinit"
              :toolbar="table_1.toolbar"
              :badges="table_1.badges"
              :fields="table_1.fields"
              :items="table_1.items"
            >
            </d-table>
            <b-button @click="tb_add"> add </b-button>
            <b-button @click="tb_disable"> disable </b-button>
          </b-col>
        </b-row> -->

        <!-- <b-row>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_2.visible"
              >Table 2 nested</b-form-checkbox
            >
            <d-table
              v-if="table_2.visible"
              classdivtable="availtable datatable nested"
              refid="table_2"
              :limit="10"
              :fields="[
                {
                  key: 'selected',
                  label: '...',
                },
                {
                  key: 'icon',
                  label: '',
                  class: 'text-center w-30px',
                },
                {
                  key: 'eventcode',
                  label: 'Event Code',
                  sortable: true,
                  class: 'text-left',
                },
                {
                  key: 'dateevent',
                  label: 'Date Event',
                  sortable: true,
                },
                {
                  key: 'eventname',
                  label: 'Event Name',
                  sortable: true,
                },
                {
                  key: 'acccode',
                  label: 'Accounting Code',
                  sortable: true,
                },
                {
                  key: 'vatregion',
                  label: 'VAT Region',
                  sortable: true,
                },
                {
                  key: 'closed',
                  label: 'Closed',
                  sortable: true,
                },
                {
                  key: 'salesgroup',
                  label: 'Sales Group',
                  sortable: true,
                },
                {
                  key: 'actions',
                  label: 'Actions',
                  class: 'actions w-100px',
                },
              ]"
              :showpages="false"
              :busy="false"
            ></d-table>
          </b-col>
        </b-row> -->
      </b-card-body>

      <b-card-body v-if="table_r.visible">
        <r-table
          v-if="table_r.visible"
          :refid="table_r.refid"
          :busy="table_r.busy"
          :icon="table_r.icon"
          :showtoolbar="table_r.showtoolbar"
          :showfab="table_r.showfab"
          :showsheets="table_r.showsheets"
          :showpages="table_r.showpages"
          :showrowcount="table_r.showrowcount"
          :showautoadd="table_r.showautoadd"
          :tools="table_r.tools"
          :fields="table_r.fields"
          :items="table_r.items"
          @click="table_r_click"
          @select="table_r_select"
        />
        <!-- 
          @click="table_r_click"
          @select="table_r_select"
          @change="updateit" -->

        <b-row class="mt-2">
          <b-col>
            <b-form-checkbox size="sm" v-model="table_r.busy"
              >Busy?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_r.showtoolbar"
              >Toolbar?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_r.showfab"
              >FAB?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_r.showsheets"
              >Sheets?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_r.showpages"
              >Pages?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_r.showrowcount"
              >Rowcount?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-checkbox size="sm" v-model="table_r.showautoadd"
              >Autoadd?</b-form-checkbox
            >
          </b-col>
          <b-col>
            <b-form-input
              type="text"
              v-model="table_r.icon"
              placeholder="Enter icon"
              size="sm"
              :style="'width: 200px'"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="small">
          <b-col>
            event: <br />
            <span v-html="table_r.event"></span>
          </b-col>
        </b-row>
      </b-card-body>

      <b-card-body v-if="reconcile.visible">
        i am reconciling
        <e-table
          v-if="reconcile.visible"
          :refid="reconcile.refid"
          :busy="reconcile.busy"
          :icon="reconcile.icon"
          :showtoolbar="reconcile.showtoolbar"
          :showfab="reconcile.showfab"
          :showsheets="reconcile.showsheets"
          :showpages="reconcile.showpages"
          :showrowcount="reconcile.showrowcount"
          :showautoadd="reconcile.showautoadd"
          :tools="reconcile.tools"
          :fields="reconcile.fields"
          :items="reconcile.items"
          @click="reconcile"
          @select="reconcile"
          @change="updateit"
        />
      </b-card-body>

      <!-- <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="3">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button
              squared
              size="sm"
              variant="primary"
              :disabled="changed.length == 0"
              @click="saveit()"
            >
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer> -->
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Multigrid",
  data() {
    return {
      locator: null,
      busy: false,
      selected: [],
      changed: [],
      table_e: {
        refid: "table_e",
        visible: false,
        busy: false,
        icon: "fa fa-power-off text-primary",
        showtoolbar: true,
        showfab: false,
        showsheets: true,
        showrowcount: false,
        showautoadd: false,
        showpages: false,
        tools: "refresh,export,add,deleteconfirm,sheet_1,sheet_2",
        fields: [],
        fields_1: [
          {
            key: "slac",
            label: "SL A/C",
            // type: "text",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "name",
            label: "Name",
            type: "text",
            placeholder: "Name",
            class: "text-right w-200px",
            clearable: "true",
          },
          {
            key: "class",
            label: "Class",
            type: "text",
            placeholder: "Class",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "agent",
            label: "Agent",
            type: "text",
            class: "text-right w-100px",
            clearable: "false",
            disabled: "true",
          },
        ],
        fields_2: [
          {
            key: "slac",
            label: "SL A/C",
            type: "text",
            // type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "name",
            label: "Name",
            type: "text",
            placeholder: "Name",
            class: "text-right w-200px",
            clearable: "true",
          },
          {
            key: "class",
            label: "Class",
            type: "text",
            placeholder: "Class",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "something",
            label: "Xtra",
            type: "text",
            class: "text-right w-100px",
            clearable: "false",
          },
          {
            key: "agent",
            label: "Agent",
            type: "text",
            class: "text-right w-100px",
            clearable: "false",
            disabled: "true",
          },
        ],
        // fields: [
        //   {
        //     key: "slac",
        //     label: "SL A/C",
        //     type: "treeselect",
        //     class: "text-center w-20pct",
        //     clearable: "true",
        //   },
        //   {
        //     key: "routing",
        //     label: "Routing",
        //     type: "text",
        //     class: "text-right w-30pct",
        //     multiple: "true",
        //     clearable: "true",
        //     datalist: ["ABC/DEF", "GHI/JKL"],
        //   },
        //   {
        //     key: "datetravel",
        //     label: "Date Travel",
        //     type: "daterangepicker",
        //     class: "text-right w-30pct",
        //     singleDatePicker: "range",
        //     opens: "left",
        //     clearable: "true",
        //   },
        //   {
        //     key: "value",
        //     label: "Value",
        //     type: "text",
        //     class: "text-right w-20pct",
        //     disabled: "true",
        //   },
        // ],
        items: [
          {
            id: "A585D0CD-66E6-406B-901E-A8E80D982C41",
            slac: "FOP2",
            routing: ["LHR", "IST", "GYD"],
            datetravel: ["2022-03-20", "2022-04-08"],
            line: "1",
            value: "0",
          },
          {
            id: "D31598CB-C72C-453A-B0A2-EE2C776B7027",
            slac: "FOP2",
            routing: "LHR/GYD",
            datetravel: ["2022-05-15", "2022-05-18"],
            line: "1",
            value: "0",
          },
          {
            id: "E40FABC1-5995-4CD7-BF7C-2F126DE9CA74",
            slac: "FOP2",
            routing: "GYD/BHX",
            datetravel: "",
            line: "2",
            value: "817.04",
          },
          {
            id: "F9BCB435-FF9F-4A69-AE66-F253E2523EF0",
            slac: "FOP2",
            routing: "GYD/FRA/LHR",
            datetravel: "",
            line: "3",
            value: "0",
          },
          {
            id: "E736F257-DD19-49E6-9097-A60DB16D9926",
            slac: "FOP2",
            routing: "GYD/IST/LHR",
            datetravel: "",
            line: "4",
            value: "0",
          },
          {
            id: "71CA1EAF-1AE8-4A2E-B3FF-2C46E13A1F07",
            slac: "FOP2",
            routing: "GYD/IST/MAN",
            datetravel: "",
            line: "5",
            value: "0",
          },
        ],
        selected: [],
        event: "",
      },
      table_d: {
        visible: false,
        busy: false,
        showtoolbar: true,
        showfab: false,
        showsheets: false,
        showrowcount: true,
        showautoadd: false,
        showpages: true,
        tools: "default,sheet_0",
        toolbar: [],
        badges: [
          {
            key: "ticketno",
            type: "pill",
            class: "orange",
          },
          {
            key: "class",
            type: "pill",
            class: "purple",
            title: "classname",
          },
          {
            key: "locator",
            type: "pill",
            class: "secondary",
          },
          {
            key: "type",
            type: "badge",
            Charter: "primary",
            Ticket: "primary",
            Reissue: "primary",
            Void: "white",
            Refund: "white",
            EMD: "purple",
          },
          {
            key: "fare_type",
            type: "badge",
            Unknown: "white",
            Negotiated: "warning",
            Net: "purple",
            Manual: "info",
            Published: "primary",
            Private: "pink",
            other: "secondary",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case "Unknown":
                  return "Unknown";
                  break;
                case "Negotiated":
                  return "Negotiated";
                  break;
                case "Net":
                  return "Net";
                  break;
                case "Manual":
                  return "Manual";
                  break;
                case "Published":
                  return "Published";
                  break;
                case "Private":
                  return "Private";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "type",
            label: "Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "dateissued",
            label: "Date Issued",
            sortable: true,
            class: "text-center",
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
            class: "text-center",
          },

          {
            key: "ticketno",
            label: "Ticket",
            sortable: true,
            class: "text-center",
          },
          {
            key: "passenger",
            label: "Name",
            sortable: true,
            class: "d-none d-sm-table-cell text-left",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 30) {
                  result = result.slice(0, 27) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "routing",
            label: "Routing",
            sortable: true,
            class: "text-center",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          {
            key: "agent",
            label: "Ag",
            sortable: true,
          },
          {
            key: "branch",
            label: "Branch",
            sortable: true,
          },
          {
            key: "fare_type",
            label: "Fare Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "fare",
            label: "Fare",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "tax",
            label: "Tax",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "lines",
            label: "#Sec",
            sortable: true,
          },
          {
            key: "errors",
            label: "#Er",
            sortable: true,
            class: "text-right",
            totalled: true,
            type: "Int",
            total: 0,
          },
          {
            key: "warnings",
            label: "#Wn",
            sortable: true,
            class: "text-right",
            totalled: true,
            type: "Int",
            total: 0,
          },
          {
            key: "locked_at",
            label: "",
            sortable: true,
          },
          {
            key: "emailed_at",
            label: "",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        items: [
          {
            type: "Ticket",
            locator: "AJFAJF",
            dateissued: "10/03/2022",
            ticketno: "ticket 1",
            passenger: "FRANCIS/ANDY",
            routing: "LGW/MAD",
            slac: "STAFFTRAV",
            eventcode: "AF22",
            agent: "AF",
            branch: "TP-1",
            fare_type: "Private",
            fare: "456.77",
            tax: "34.70",
            errors: "0",
            warnings: "0",
            lines: "1",
            rows: 16,
          },
          {
            type: "Ticket",
            locator: "AJFMJF",
            dateissued: "10/03/2022",
            ticketno: "ticket 2",
            passenger: "FRANCIS/MATTHEW",
            routing: "LGW/MAD",
            slac: "STAFFTRAV",
            eventcode: "AF22",
            agent: "AF",
            branch: "TP-1",
            fare_type: "Net",
            fare: "377.10",
            tax: "18.50",
            errors: "2",
            warnings: "4",
            lines: "1",
            rows: 16,
          },
          {
            type: "Ticket",
            locator: "AJFHTF",
            dateissued: "10/03/2022",
            ticketno: "ticket 3",
            passenger: "FRANCIS/HARRY",
            routing: "LGW/MAD",
            slac: "STAFFTRAV",
            eventcode: "AF22",
            agent: "AF",
            branch: "TP-1",
            fare_type: "Manual",
            fare: "122.50",
            tax: "14.25",
            errors: "2",
            warnings: "4",
            lines: "1",
            rows: 16,
          },
        ],
      },
      table_r: {
        refid: "table_r",
        visible: false,
        busy: false,
        icon: "fa fa-power-off text-primary",
        showtoolbar: true,
        showfab: false,
        showsheets: true,
        showrowcount: false,
        showautoadd: false,
        showpages: false,
        tools: "refresh,export,textsize,sheet_1,sheet_2",
        fields: [
          {
            key: "event",
            label: "Event",
            // type: "text",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "race",
            label: "Race",
            type: "text",
            placeholder: "Race",
            class: "text-right w-200px",
            clearable: "true",
          },
          {
            key: "department",
            label: "Department",
            type: "text",
            placeholder: "Department",
            class: "text-right w-200px",
            clearable: "true",
          },
          {
            key: "passenger",
            label: "Passenger",
            type: "text",
            placeholder: "Passenger",
            class: "text-right w-200px",
            clearable: "true",
          },
          {
            key: "ticketno",
            label: "Ticket No",
            type: "text",
            placeholder: "Ticket No",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "flightno",
            label: "Flight No",
            type: "text",
            placeholder: "Flight No",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "datetravel",
            label: "Date Travel",
            type: "daterangepicker",
            class: "text-right w-30pct",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
        ],
        items: [
          {
            event: "FRAHUN22",
            passenger: "COOPER/PAULMR",
            ticketno: "CH2281178",
            datetravel: "25/07/2022",
            flightno: "XZ4250",
          },
          {
            event: "FRAHUN22",
            passenger: "FRANKS/WAYNEMR",
            ticketno: "CH2281179",
            datetravel: "25/07/2022",
            flightno: "XZ4250",
          },
          {
            event: "FRAHUN22",
            passenger: "HARPER/DAVIDMR",
            ticketno: "CH2281180",
            datetravel: "25/07/2022",
            flightno: "XZ4250",
          },
          {
            event: "FRAHUN22",
            passenger: "SPARE/ONEMR",
            ticketno: "CH2281181",
            datetravel: "25/07/2022",
            flightno: "XZ4250",
          },
          {
            event: "FRAHUN22",
            passenger: "WILLS/PHILLIPMR",
            ticketno: "CH2281182",
            datetravel: "25/07/2022",
            flightno: "XZ4250",
          },
          {
            event: "FRAHUN22",
            passenger: "TIDESWELL/STEVENMR",
            ticketno: "5044326549",
            datetravel: "22/07/2022",
            flightno: "LH1342|LH947",
          },
          {
            event: "FRAHUN22",
            passenger: "HUMBLE/CLAIREMS",
            ticketno: "5044326375",
            datetravel: "01/08/2022",
            flightno: "LH1683|LH2500",
          },
          {
            event: "FRAHUN22",
            passenger: "TIDESWELL/STEVENMR",
            ticketno: "5044280168",
            datetravel: "26/07/2022",
            flightno: "LH1678|LH2249",
          },
          {
            event: "FRAHUN22",
            passenger: "HUMBLE/CLAIREMS",
            ticketno: "5044259322",
            datetravel: "02/08/2022",
            flightno: "LH1677|LH2502",
          },
          {
            event: "FRAHUN22",
            passenger: "NOON/PAULMR",
            ticketno: "5044222886",
            datetravel: "23/07/2022",
            flightno: "BA1385|BA874",
          },
          {
            event: "FRAHUN22",
            passenger: "ACKERMAN/NADINEMS",
            ticketno: "9503635896",
            datetravel: "04/07/2022",
            flightno: null,
          },
          {
            event: "FRAHUN22",
            passenger: "ACKERMAN/NADINEMS",
            ticketno: "5044204604",
            datetravel: "25/07/2022",
            flightno: "BA874",
          },
          {
            event: "FRAHUN22",
            passenger: "TIDESWELL/STEVENMR",
            ticketno: "5044175596",
            datetravel: "19/07/2022",
            flightno: "LH1678|LH2249",
          },
          {
            event: "FRAHUN22",
            passenger: "HUMBLE/CLAIREMS",
            ticketno: "5044175548",
            datetravel: "02/08/2022",
            flightno: "LH1677|LH2502",
          },
          {
            event: "FRAHUN22",
            passenger: "ACKERMAN/NADINEMS",
            ticketno: "5044175545",
            datetravel: "24/07/2022",
            flightno: "BA868",
          },
          {
            event: "FRAHUN22",
            passenger: "NOON/PAULMR",
            ticketno: "5044175507",
            datetravel: "01/08/2022",
            flightno: "AF1168|AF1295",
          },
          {
            event: "FRAHUN22",
            passenger: "NOON/PAULMR",
            ticketno: "5044175506",
            datetravel: "23/07/2022",
            flightno: "BA1389|BA874",
          },
          {
            event: "FRAHUN22",
            passenger: "BECKETT/DAVIDMR",
            ticketno: "5044175503",
            datetravel: "01/08/2022",
            flightno: "AF1168|AF1295",
          },
          {
            event: "FRAHUN22",
            passenger: "ALBROW/DENISEMS",
            ticketno: "5044175501",
            datetravel: "24/07/2022",
            flightno: "BA868",
          },
          {
            event: "FRAHUN22",
            passenger: "LLOYD/JOSEPHMR",
            ticketno: "5044175500",
            datetravel: "01/08/2022",
            flightno: "AF1168|AF1295",
          },
          {
            event: "FRAHUN22",
            passenger: "QUINN/ALANMR",
            ticketno: "5044175499",
            datetravel: "24/07/2022",
            flightno: "BA868",
          },
          {
            event: "FRAHUN22",
            passenger: "TIDESWELL/STEVENMR",
            ticketno: "5044175495",
            datetravel: "20/07/2022",
            flightno: "LH1678|LH2249",
          },
          {
            event: "FRAHUN22",
            passenger: "LANFEAR/DANIELMR",
            ticketno: "5044175494",
            datetravel: "01/08/2022",
            flightno: "AF1268|AF1295",
          },
          {
            event: "FRAHUN22",
            passenger: "FERRARI/VALENTINOMR",
            ticketno: "5044175456",
            datetravel: "01/08/2022",
            flightno: "LH1343|LH254",
          },
          {
            event: "FRAHUN22",
            passenger: "ILLSEY/BENJAMINMR",
            ticketno: "5044158982",
            datetravel: "21/07/2022",
            flightno: "AF1494|AF7663",
          },
          {
            event: "FRAHUN22",
            passenger: "PREECE/JONATHANMR",
            ticketno: "5044158983",
            datetravel: "21/07/2022",
            flightno: "AF1494|AF7663",
          },
          {
            event: "FRAHUN22",
            passenger: "LEE/CHARLOTTEMS",
            ticketno: "5044158981",
            datetravel: "22/07/2022",
            flightno: "BA336",
          },
          {
            event: "FRAHUN22",
            passenger: "WEBSTER/CAROLYNMS",
            ticketno: "5044158980",
            datetravel: "20/07/2022",
            flightno: "LX406|LX407|LX580|LX581",
          },
          {
            event: "FRAHUN22",
            passenger: "LLOYD/JOSEPHMR",
            ticketno: "5044158970",
            datetravel: "18/07/2022",
            flightno: "LH1088|LH943",
          },
          {
            event: "FRAHUN22",
            passenger: "DAVIES/JAMESMR",
            ticketno: "5044135640",
            datetravel: "15/07/2022",
            flightno: "AF1669|AF7682",
          },
          {
            event: "FRAHUN22",
            passenger: "QUIGLEY/THOMASMR",
            ticketno: "5044135639",
            datetravel: "15/07/2022",
            flightno: "AF1669|AF7682",
          },
          {
            event: "FRAHUN22",
            passenger: "CALLAGHAN/FRASERMR",
            ticketno: "5044106145",
            datetravel: "01/08/2022",
            flightno: "BA1492|BA869",
          },
          {
            event: "FRAHUN22",
            passenger: "BURTON/JAMESMR",
            ticketno: "5044077084",
            datetravel: "20/07/2022",
            flightno: "KL1977",
          },
        ],
        selected: [],
      },
      reconcile: {
        visible: true,
        refid: "table_reconcile",
        title: "Reconcile Statement",
        icon: "fa fa-check-circle-o text-success",
        debounce: 500,
        busy: false,
        page: 1,
        filter: false,
        tools: "go,filter",
        fields: [
          {
            key: "ritem",
            label: "Reconcile Statement",
            type: "rinput",
            class: "text-left w-90pct",
            clearable: "true",
          },
        ],
        items: [
          {
            id: "EA0E385E-73DF-4110-858B-06CD5638A440",
            amount: 1000
          },
          {
            id: "6446821D-A053-4BB2-AC6D-3709A73CF5B7",
            amount: 2000
          },
          {
            id: "10C3E7AC-0069-48D2-8C69-4B59EAB57506",
            amount: 3000
          },
          {
            id: "7BC6800D-48EC-4F9D-B024-7EF87DB5605C",
            amount: 40000
          },
          {
            id: "9F94C982-5C96-49D0-B29D-C4E2248DF970",
            amount: 50000
          }
        ]
      }
    };
  },
  mounted() {
    this.table_e.fields = this.table_e.fields_1;
  },
  methods: {
    async table_d_click(a, ss) {
      console.log("table_d_click", a, ss);
      this.table_e.event =
        "table_d_click()<br/>select:" +
        JSON.stringify(a) +
        "<br/>tools:" +
        JSON.stringify(ss);

      switch (a) {
        case "refresh":
          this.table_d.busy = !this.table_e.busy;
          this.selected = [];
          this.changed = [];
          break;
        case "selectall":
          this.table_d.selectall = !this.table_d.selectall;
          break;
        case "add":
          break;
        case "delete":
          // this.deleteit(ss);
          break;
      }
    },
    async table_e_click(a, ss) {
      console.log("table_e_click", a, ss);
      this.table_e.event =
        "table_e_click()<br/>click:" +
        JSON.stringify(a) +
        "<br/>tools:" +
        JSON.stringify(ss);

      switch (a) {
        case "sheet_0":
        case "sheet_1":
        case "sheet_2":
        case "sheet_3":
          this.table_e.fields = this.table_e["fields_" + a.slice(-1)];
          break;

        case "refresh":
          this.table_e.busy = !this.table_e.busy;
          this.selected = [];
          this.changed = [];
          break;
        case "add":
          break;
        case "delete":
          // this.deleteit(ss);
          break;
      }
    },
    async table_e_select(ss, tools) {
      this.table_e.event =
        "table_e_select()<br/>select:" +
        JSON.stringify(ss) +
        "<br/>tools:" +
        JSON.stringify(tools);

      let tool = null;

      if (tools) {
        tool = tools.find((o) => o.action == "refresh");
        if (tool) {
          tool.disabled = false;
        }
        tool = tools.find((o) => o.action == "export");
        if (tool) {
          tool.disabled = false;
        }
        tool = tools.find((o) => o.action == "add");
        if (tool) {
          tool.disabled = false;
        }
        tool = tools.find((o) => o.action == "sheet_1");
        if (tool) {
          tool.disabled = false;
        }
        tool = tools.find((o) => o.action == "sheet_2");
        if (tool) {
          tool.label = "Sheet icon added";
          tool.icon = "fa fa-bed mr-1";
          tool.disabled = false;
        }

        tool = tools.find((o) => o.action == "deleteconfirm");
        if (tool) {
          tool.disabled = ss.length > 0 ? false : true;
        }
      }

      this.table_e.selected = ss;
    },

    async table_r_click(a, ss) {
      console.log("table_r_click", a, ss);
      this.table_e.event =
        "table_r_click()<br/>click:" +
        JSON.stringify(a) +
        "<br/>tools:" +
        JSON.stringify(ss);

      switch (a) {
        case "sheet_0":
        case "sheet_1":
        case "sheet_2":
          this.table_r.fields = this.table_r["fields_" + a.slice(-1)];
          break;

        case "refresh":
          this.table_r.busy = !this.table_r.busy;
          this.selected = [];
          this.changed = [];
          break;
      }
    },
    async table_r_select(ss, tools) {
      this.table_r.event =
        "table_r_select()<br/>select:" +
        JSON.stringify(ss) +
        "<br/>tools:" +
        JSON.stringify(tools);

      let tool = null;

      if (tools) {
        tool = tools.find((o) => o.action == "refresh");
        if (tool) {
          tool.disabled = false;
        }
        tool = tools.find((o) => o.action == "export");
        if (tool) {
          tool.disabled = false;
        }
        tool = tools.find((o) => o.action == "textsize");
        if (tool) {
          tool.disabled = false;
        }

        tool = tools.find((o) => o.action == "sheet_1");
        if (tool) {
          tool.disabled = false;
        }
        tool = tools.find((o) => o.action == "sheet_2");
        if (tool) {
          tool.label = "F1.xlsx";
          tool.icon = "fa fa-file-excel-o mr-1";
          tool.disabled = false;
        }
      }

      this.table_r.selected = ss;
    },

    // THESE GET IMPLEMENTED IN LOCAL COMPONENT
    updateit(e) {
      console.log("updateit", e);
      this.changed = e;
    },

    saveit() {
      console.log("saveit", this.changed);
    },
    deleteit(e) {
      console.log("deleteit", e);
      this.selected = e;
    },
    tb_add() {
      this.table_1.toolbar.push({
        type: "button",
        size: "sm",
        variant: "outline-white",
        squared: "squared",
        icon: "fa fa-filter text-primary",
        position: "toolbar",
        action: "filter",
        label: "Filter",
        disabled: false,
        component: {
          name: "",
        },
      });
    },
    tb_disable() {
      let tool = this.table_1.toolbar.find((o) => o.action == "filter");
      console.log(tool);
      if (tool) {
        tool.disabled = !tool.disabled;
      }
    },
  },
};
</script>
